import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, from, of } from 'rxjs';
import { AppAnuncios } from '../models/appAnuncios.model';
import { AppEmpresasService } from './appEmpresasService.service';

import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { Utilidades } from '../helper/utilidades';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LivesSessionHelper } from '../helper/livesSessionHelper';

//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable({ providedIn: 'root' })
export class AppAnunciosService extends HttpClientBaseService implements IServiceBase<AppAnuncios> {



  constructor(
    _http: HttpClient,
    private appEmpresasService: AppEmpresasService,
    private _livesSession: LivesSessionHelper,
  ) {
    super(_http, '/user/', '', false);


  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppAnuncios>> {
    throw new Error('Method not implemented.');
  }


  getAllModels(): Observable<AppAnuncios[]> {
    const environmentId = this._livesSession.EnvironmentId;

    return from(this.loadUserCompanies()).pipe(
      switchMap(userCompanies => {
        let companiesFilter = userCompanies.map(company => `companyIds=${company}`).join('&');
        return this.appEmpresasService.getAllModelsByEnvironment(environmentId).pipe(
          switchMap(empresas => {
            
            if (empresas.length === 0) {
              return of([] as AppAnuncios[]);
            }

            const observables = empresas.map(empresa => {
              const url = userCompanies.length > 0 ?
                `${AppConfig.settings.apiServerPE.apiUrl}announcements/hrvalidator?${companiesFilter}` :
                `${AppConfig.settings.apiServerPE.apiUrl}announcements/hrvalidator?companyIds=1`;

              const headers = new HttpHeaders({
                'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
              });

              return this.http.get<AppAnuncios[]>(url, { headers }).pipe(
                catchError(() => of([] as AppAnuncios[]))
              );
            });

            return forkJoin(observables).pipe(
              map(results => {
                const allAnuncios = results.reduce((acc, val) => acc.concat(val), [] as AppAnuncios[]);
                const uniqueAnuncios = Array.from(new Set(allAnuncios.map(a => a.announcement1)))
                  .map(id => allAnuncios.find(a => a.announcement1 === id));
                return uniqueAnuncios;
              })
            );
          })
        );
      })
    );
  }



  public getModel(id: any): Observable<AppAnuncios> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}announcements?top=1&fields=company1&operator=eq&values=${id}`;

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppAnuncios>(url, { headers: headers });
  }

  public updateModel(id: string, data: any): Observable<AppAnuncios> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}announcement?announcement=${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<AppAnuncios>(url, data, { headers: headers });
  }

  public createModel(data: Partial<AppAnuncios>): Observable<AppAnuncios> {

    const url = `${AppConfig.settings.apiServerPE.apiUrl}announcement`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.post<AppAnuncios>(url, data, { headers: headers });
  }

 

  private async loadUserCompanies(): Promise<string[]> {
    try {
      let loggedUserCompanies: string[] = [];
      const result = await this.appEmpresasService.getHrValidatorCompaniesIds(this._livesSession.AspNetUserId).toPromise();
      result.companies.map((company) => {
        if (company.company1) {
          loggedUserCompanies.push(company.company1);
        }
      });
      return loggedUserCompanies
    } catch (error) {
      console.error(`Error getHrValidatorCompaniesIds`, error);
    }
  }

}
